<template>
  <b-form @submit.prevent="onSubmit">
    <b-container>
      <b-row>
        <h3>Przetestuj ustawienia poczty</h3>
      </b-row>

      <b-row>
        <b-col cols="6">
          <b-row>
            <b-form-group label="Email">
              <b-form-input v-model="email" type="text" autocomplete="off" />
              <b-form-invalid-feedback>Niepoprawny adres email</b-form-invalid-feedback>
            </b-form-group>
          </b-row>

          <b-row>
            <b-form-group>
              <b-button class="float-right" type="submit" variant="primary" :disabled="loading">
                <span v-show="!loading">Wyślij testowy email</span>
                <span v-show="loading">
                  <b-spinner small label="Loading..."></b-spinner>
                </span>
              </b-button>
            </b-form-group>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </b-form>
</template>

<script>
import { axios, eventBus } from "@/_infrastructure";
import { required, email } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      email: "",
      loading: false
    };
  },
  validations: {
    email: {
      required,
      email
    }
  },
  computed: {
    required() {
      return this.host.length > 0;
    },
    passwordType() {
      return this.hidePassword ? "password" : "text";
    },
    passwordIcon() {
      return this.hidePassword ? "eye" : "eye-slash";
    }
  },
  methods: {
    onSubmit() {
      if (!this.$v.$error) {
        this.loading = true;

        axios
          .post("/Settings/email/test", {
            email: this.email
          })
          .then(() => {
            //this.email = "";
            eventBus.$emit("notify-success", "Wysłano poprawnie.");
          })
          .catch(error => eventBus.$emit("unhandled-error", error))
          .then(() => (this.loading = false));
      }
    },
    swapType() {
      this.hidePassword = !this.hidePassword;
    },
    goto(url) {
      this.$router.push(url);
    }
  }
};
</script>

<style lang="scss" scoped>
fieldset.form-group {
  width: 90%;
}
</style>